/**
 * Directive: dayPicker
 */
angular.module('acme.common.directive.dayPicker', [])
.directive('dayPicker', [function() {

    return {
      restrict: 'A',
      replace: true,
      templateUrl: 'common/directives/dayPicker/dayPicker.tpl.html',
      scope: {
        model: '='
      },
      
      link: function($scope, $element, $attrs) {
        // Modified after controller runs
      },

      controller: ['$scope', function($scope) {

        $scope.dayPicker = {

          days: ['Su', 'M', 'Tu', 'W', 'Th', 'F', 'Sa'],

          isSelected: function(day) {
            var r = false;
            
            if ($scope.model instanceof Array) {
              r = ($scope.model.indexOf(day) >= 0);
            }

            return r;
          },

          toggle: function(day) {
            if (!this.isSelected(day)) {
              $scope.model.push(day);
            }else{
              $scope.model.splice($scope.model.indexOf(day), 1);
            }
          }
        };

      }]

    };

}]);